import { useContext, useMemo } from "react";
import styles from "./PrysmPannel.module.css";
import { AppStateContext } from "../../../state/AppProvider";

interface PrysmPanelProps {
  allCategoryData: any[];
  onSelectQuestion: (question: string) => void;
}

const pickRandomQuestion = (titles: any[] = []) => {
  if (!titles.length) return "";
  const randomIndex = Math.floor(Math.random() * titles.length);
  return titles[randomIndex]?.Question || "";
};

export function PrysmPanel({
  allCategoryData,
  onSelectQuestion,
}: PrysmPanelProps) {
  const appStateContext = useContext(AppStateContext);
  const selectedAI = appStateContext?.state.selectedAI || "";
  const selectedAIKey = selectedAI.trim().toLowerCase().replace(/\s+/g, "");
  const isNanoBanana = selectedAIKey.includes("nanobanana");

  const topThreeCategories = useMemo(() => {
    if (!Array.isArray(allCategoryData)) {
      return [];
    }

    const unique = new Map<string, any>();

    allCategoryData.forEach((item) => {
      if (
        item?.CategoryField === "Model" &&
        item?.IsActive !== false &&
        item?.SubCategory &&
        (isNanoBanana || item.SubCategory !== "Create Image") &&
        !unique.has(item.SubCategory)
      ) {
        const displayLabel =
          item.SubCategory === "Create Image" && !isNanoBanana
            ? "Visual Ideas"
            : item.SubCategory;
        unique.set(item.SubCategory, { ...item, DisplayLabel: displayLabel });
      }
    });

    return Array.from(unique.values()).slice(0, 3);
  }, [allCategoryData, isNanoBanana]);

  return (
    <div className={styles.prysmPanelWrapper}>
      <div className={styles.prysmButtonRow}>
        {topThreeCategories.map((item) => (
          <button
            key={item.SubCategoryKey || item.SubCategory}
            className={styles.prysmButton}
            onClick={() => {
              const question = pickRandomQuestion(item.Titles);
              if (question) {
                onSelectQuestion(question);
              }
            }}
          >
            {item.DisplayLabel || item.SubCategory}
          </button>
        ))}
      </div>
    </div>
  );
}
